import React from "react";
import { DropDown, RollingLoader } from "../../../commons";
import { countryCode } from "../../../../constant/countryCode";
import { ContactDetails } from "../../../../redux/auth/authTypes";
import "./Communications.scss";
type profileDetailsErrorType = {
  nameError: string;
  emailError: string;
  newPasswordError: string;
  newPasswordAgainError: string;
  countryError: string;
  stateError: string;
  cityError: string;
};
type AppProps = {
  data: ContactDetails;
  isEdit?: boolean | string;
  setProfileForm: any;
  handleCommunicationsDetails: (data: any) => void;
  isMobileNo?: number | null;
  mobileFetching?: boolean;
  mobileMessage?: string | null;
  profileDetailsError?: profileDetailsErrorType
};
const Communications = ({
  data,
  isEdit,
  setProfileForm,
  handleCommunicationsDetails,
  isMobileNo,
  mobileFetching,
  mobileMessage,
  profileDetailsError
}: AppProps) => {
  const option: any = countryCode?.map((e: any) => {
    return {
      label: `${e?.flag} ${e?.name}(${e?.dial_code})`,
      value: e?.dial_code,
    };
  });
  const selectStyle = {
    option: (baseStyles: any, state: any) => ({
      ...baseStyles,

      whiteSpace: "wrap",
    }),
    control: (provided: any, state: any) => ({
      ...provided,
      width: "80px",
      fontSize: "14px",
      borderTopRightRadius: "0px",
      borderBottomRightRadius: "0px",
      borderRight: "0px",
      "&:hover": { borderColor: "none" },
      border: "1px solid rgba(0, 0, 0, 0.125)",
      boxShadow: "none", // no box-shadow
    }),
    container: (provided: any) => ({
      ...provided,
      width: 365,
      position: "absolute",
    }),
    indicatorSeparator: (provided: any, state: any) => ({
      ...provided,
      padding: "0px",
      display: "none",
    }),
    dropdownIndicator: (provided: any, state: any) => ({
      ...provided,
      padding: "0px",
    }),
    myDropDown__indicator: (base: any) => ({
      ...base,
      "&.myDropDown__dropdown-indicator": {
        "&.indicatorContainer": {
          color: "#000000",
          padding: "1px",
        },
      },
    }),
  };
  return (
    <div className="form-group">
      <h6>COMMUNICATIONS</h6>
      <div className="row">
        <div className="col-md-3">
          <label htmlFor="twitterId">Personal Email ID</label>
          <div className="d-flex flex-row position-relative">
            <input
              type="text"
              className="form-control"
              name="personal_email_id"
              disabled={!isEdit}
              value={data?.personal_email_id || ""}
              onChange={handleCommunicationsDetails}
            />
          </div>
          <div>
            {profileDetailsError && profileDetailsError?.emailError?.length ? (
              <small className="text-danger">
                {profileDetailsError?.emailError}
              </small>
            ) : (
              ""
            )}
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-md-3">
          <label htmlFor="mobile">Mobile</label>

          <div style={{ display: "flex", gap: "2px", position: "relative" }}>
            <DropDown
              options={option}
              value={{ value: "+91", label: "+91" }}
              // handleChange={handleCommunicationsDetails}
              // disabled={!isEdit}
              disabled
              style={selectStyle}
            />

            <input
              type="number"
              className="form-control dropDown-input"
              name="mobile"
              style={{
                borderTopLeftRadius: "00px",
                borderBottomLeftRadius: "0px",
              }}
              disabled={!isEdit}
              value={data?.mobile || ""}
              onChange={handleCommunicationsDetails}
              onWheel={(event) => event.currentTarget.blur()}
            />
            {mobileFetching && data?.mobile && <RollingLoader />}
          </div>
          {data?.mobile &&
            isMobileNo === 1 &&
            mobileMessage?.includes("mobile") ? (
            <small className="text-danger">
              Mobile number is already in use!
            </small>
          ) : (
            ""
          )}
        </div>

        <div className="col-md-3">
          <label htmlFor="whatsappNumber">Whatsapp Number</label>
          <div style={{ display: "flex", gap: "2px" }}>
            <DropDown
              options={option}
              value={{ value: "+91", label: "+91" }}
              style={selectStyle}
              disabled
            />
            <input
              type="number"
              className="form-control dropDown-input"
              style={{
                borderTopLeftRadius: "00px",
                borderBottomLeftRadius: "0px",
              }}
              name="whatsapp_number"
              value={data?.whatsapp_number || ""}
              onChange={handleCommunicationsDetails}
              onWheel={(event) => event.currentTarget.blur()}
              disabled={!isEdit}
            />
          </div>
        </div>
        <div className="col-md-3">
          <label htmlFor="whatsappNumber">Work Phone</label>
          <div style={{ display: "flex", gap: "2px" }}>
            <DropDown
              options={option}
              value={{ value: "+91", label: "+91" }}
              style={selectStyle}
              disabled
            />
            <input
              type="number"
              className="form-control dropDown-input"
              style={{
                borderTopLeftRadius: "00px",
                borderBottomLeftRadius: "0px",
              }}
              name="work_phone"
              value={data?.work_phone || ""}
              disabled={!isEdit}
              onChange={handleCommunicationsDetails}
            />
          </div>
        </div>
      </div>
      <div className="row mt-3">
        <div className="col-md-3">
          <label htmlFor="twitterId">Emergency Contact Person</label>
          <div className="d-flex flex-row position-relative">
            <input
              type="text"
              className="form-control"
              name="emergency_contact_person"
              disabled={!isEdit}
              value={data?.emergency_contact_person || ""}
              onChange={handleCommunicationsDetails}
            />
          </div>
        </div>
        <div className="col-md-3">
          <label htmlFor="whatsappNumber">Emergency Contact Number</label>
          <div style={{ display: "flex", gap: "2px" }}>
            <DropDown
              options={option}
              value={{ value: "+91", label: "+91" }}
              style={selectStyle}
              disabled
            />
            <input
              type="number"
              className="form-control dropDown-input"
              style={{
                borderTopLeftRadius: "00px",
                borderBottomLeftRadius: "0px",
              }}
              onChange={handleCommunicationsDetails}
              value={data?.emergency_contact_number || ""}
              name="emergency_contact_number"
              disabled={!isEdit}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Communications;
